import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl} from '@angular/forms';

export interface SelectOption {
  id: string;
  description: string;
}

@Component({
  selector: 'app-dropdown-select',
  templateUrl: './dropdown-select.component.html',
  styleUrls: ['./dropdown-select.component.scss']
})
export class DropdownSelectComponent {

  @Input() public control = new FormControl();
  @Input() public fieldName: string;
  @Input() public label: string;
  @Input() public hint: string;
  @Input() public placeholder: string;
  @Input() public options: Array<SelectOption>;
  @Input() public showErrors: boolean;
  @Input() public showIconError = true;
  @Output() selectedOption = new EventEmitter<SelectOption>();
  public arrowOpen = false;


  selectOption(optionId) {
    const selectedOption =  this.options.find((option) => option.id === optionId);
    if (!selectedOption) {
      return;
    }
    if (this.control && this.fieldName) {
      this.control.setValue(selectedOption.id);
    }
    this.selectedOption.emit(selectedOption);
  }

  captureClickEvent() {
    this.arrowOpen = true;
  }

  checkIfFieldHasNotValueAndMarkAsTouched() {
    this.arrowOpen = false;
    this.control.markAsTouched();
  }
}
